import { render } from "./AddLeg.vue?vue&type=template&id=633046ad&scoped=true"
import script from "./AddLeg.vue?vue&type=script&lang=js"
export * from "./AddLeg.vue?vue&type=script&lang=js"

import "./AddLeg.vue?vue&type=style&index=0&id=633046ad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633046ad"]])

export default __exports__